module.exports = __webpack_public_path__ + "img/individual-2.df32aa6.png";